











import {Component, Prop, Vue} from 'vue-property-decorator'
import TextField from "@/components/UI/TextField.vue";

@Component({
    components: {
        TextField,
    },
})
export default class DialogTextField extends Vue {
    @Prop() private fieldTitle!: string;
    @Prop() private value!: string;
}
